import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import {
    GedCriteresFiltrageGedModelInput,
    GedInitialisationModuleGestionGedAlbumModel,
    GedListeAlbumsGedModel,
    MutationGetInitialisationAdmninistrationAlbumsArgs,
    PortailDocumentCategorieDto,
    PortailStatutDto,
    PortailAlbumDto
} from 'src/graphql/generated-types';
import { Injectable } from '@angular/core';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import {
    ResetWebAdministrationDocumentaryManagementAction,
    WebAdministrationDocumentaryManagementInitRelatedListsAction,
    WebAdministrationDocumentaryManagementSetFiltersAction,
    WebAdministrationDocumentaryManagementSetSelectedRecordAction,
    WebAdministrationDocumentaryManagementToggleFiltersAction
} from 'src/app/board/web-administration/stores/web-administration-documentary-management/web-administration-documentary-management-record/web-administration-documentary-management-record.action';
import { Observable } from 'rxjs';
import gql from 'graphql-tag';
import {
    DocumentaryManagementRecordFragment
} from 'src/app/board/web-administration/fragments/documentary-management-record.fragment';
import { tap } from 'rxjs/operators';

export class WebAdministrationDocumentaryManagementStateModel {
    recordListModel: GedListeAlbumsGedModel | null = null;
    selectedRecord: PortailAlbumDto | null = null;
    statusList: PortailStatutDto[] = [];
    categoriesList: PortailDocumentCategorieDto[] = [];

    isFiltersOpened = false;
    recordListFilters: GedCriteresFiltrageGedModelInput | null = null;
}

@State<WebAdministrationDocumentaryManagementStateModel>({
    name: 'documentaryManagementRecord',
    defaults: new WebAdministrationDocumentaryManagementStateModel()
})
@Injectable()
export class WebAdministrationDocumentaryManagementRecordState {

    constructor(private store: Store,
                private graphqlService: GraphqlService) {
    }

    @Selector()
    public static recordListModel(state: WebAdministrationDocumentaryManagementStateModel): GedListeAlbumsGedModel {
        return state.recordListModel;
    }

    @Selector()
    public static selectedRecord(state: WebAdministrationDocumentaryManagementStateModel): PortailAlbumDto | null {
        return state.selectedRecord;
    }

    @Selector()
    public static isFiltersOpened(state: WebAdministrationDocumentaryManagementStateModel): boolean {
        return state.isFiltersOpened;
    }

    @Selector()
    public static filters(state: WebAdministrationDocumentaryManagementStateModel): GedCriteresFiltrageGedModelInput {
        return state.recordListFilters;
    }

    @Selector()
    public static statusList(state: WebAdministrationDocumentaryManagementStateModel): PortailStatutDto[] {
        return state.statusList;
    }

    @Selector()
    public static categoriesList(state: WebAdministrationDocumentaryManagementStateModel): PortailDocumentCategorieDto[] {
        return state.categoriesList;
    }

    @Action(WebAdministrationDocumentaryManagementInitRelatedListsAction)
    loadRelatedInitList({patchState}: StateContext<WebAdministrationDocumentaryManagementStateModel>): Observable<GedInitialisationModuleGestionGedAlbumModel> {
        return this.graphqlService.mutateOne<'getInitialisationAdmninistrationAlbums', MutationGetInitialisationAdmninistrationAlbumsArgs>({
            mutation: gql`
                mutation getInitialisationAdmninistrationAlbums($contexte: ContextInfosInput) {
                    getInitialisationAdmninistrationAlbums(contexte: $contexte) {
                        ListeAlbums {
                            ...ListeAlbumsFragment
                        }
                        ListeStatut {
                            PortailStatutDTO {
                                Code
                                Id
                                IsActif
                                Libelle
                            }
                        }
                        ListeCategories {
                            PortailDocumentCategorieDTO {
                                Code
                                Id
                                Libelle
                            }
                        }
                    }
                }
                ${DocumentaryManagementRecordFragment.recordListFragment}
            `
        }).pipe(
            tap(getInitialisationAdmninistrationAlbums => patchState({
                recordListModel: getInitialisationAdmninistrationAlbums?.ListeAlbums || null,
                categoriesList: getInitialisationAdmninistrationAlbums?.ListeCategories?.PortailDocumentCategorieDTO || [],
                statusList: getInitialisationAdmninistrationAlbums?.ListeStatut?.PortailStatutDTO || []
            }))
        );
    }

    @Action(WebAdministrationDocumentaryManagementSetFiltersAction)
    setFilters(
        {patchState}: StateContext<WebAdministrationDocumentaryManagementStateModel>,
        {filters}: WebAdministrationDocumentaryManagementSetFiltersAction
    ): void {
        patchState({
            recordListFilters: filters
        });
    }

    @Action(WebAdministrationDocumentaryManagementToggleFiltersAction)
    toggleFilters({getState, patchState}: StateContext<WebAdministrationDocumentaryManagementStateModel>,
                  {isFiltersOpened}: WebAdministrationDocumentaryManagementToggleFiltersAction): void {
        patchState({
            isFiltersOpened: isFiltersOpened ?? !getState().isFiltersOpened
        });
    }

    @Action(ResetWebAdministrationDocumentaryManagementAction)
    resetState({patchState}: StateContext<WebAdministrationDocumentaryManagementStateModel>): void {
        patchState(new WebAdministrationDocumentaryManagementStateModel());
    }

    @Action(WebAdministrationDocumentaryManagementSetSelectedRecordAction)
    setSelectedRecord(
        {patchState}: StateContext<WebAdministrationDocumentaryManagementStateModel>,
        {selectedRecord}: WebAdministrationDocumentaryManagementSetSelectedRecordAction
    ): void {
        patchState({
            selectedRecord
        });
    }
}
